import Echo from 'laravel-echo';
import Pusher from 'pusher-js';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { LocalStorageService } from './local-storage.service';
import { TaskboardTableService } from 'src/app/modals/Taskboard/taskboard-table.service';
import { Store } from '@ngrx/store';
import { fetchUnread } from 'src/app/modals/Taskboard/taskboard.action';
import { User } from 'src/app/modals/Authentication/auth.models';
import { AlertService } from './alert.service';
import { PermissionService } from './permission.service';

(window as any).Pusher = Pusher;


@Injectable({ providedIn: 'root' })

//This should only be imported within topbar and called init and no where else
export class EchoService {
    
    private subscribedChannels = new Set<string>();
    public echo!: Echo<any>; // Mark as late-init
    socketId: string;
    currentUser: User;

    constructor(
        private permissionService: PermissionService, 
        private http: HttpClient,
        private localStorageService: LocalStorageService,
        private taskTableService: TaskboardTableService,
        private store: Store,
        private alertService: AlertService
    ) {
        this.currentUser = this.localStorageService.getItem('currentUser');
    }

    initEcho(): void {

        this.echo = new Echo({
            broadcaster: 'pusher',
            key: 'b7f1a102f794f3cdadc1',
            cluster: 'eu',
            forceTLS: environment.env !== "local",
            authorizer: (channel: any, options: any) => {
                return {
                    authorize: (socketId: string, callback: Function) => {

                        this.http.post(
                            `${environment.backend_web}broadcasting/auth`,
                            {
                                socket_id: socketId,
                                channel_name: channel.name,
                            },
                            { withCredentials: true }
                        ).subscribe(
                            (response) => callback(null, response),
                            (error) => callback(error)
                        );
                    }
                };
            }
        });

        this.echo.connector.pusher.connection.bind('connected', () => {
            this.socketId = this.echo.socketId();
        });
    }

    fetchTaskCount(){
        if(this.permissionService.has('c-communication-view') && this.permissionService.has('c-communication-edit'))
            this.store.dispatch(fetchUnread());
    }

    areArraysIdentical(arr1: any[], arr2: any[]): boolean {
        if (arr1.length !== arr2.length) {
          return false;
        }
      
        const sortedArr1 = [...arr1].sort();
        const sortedArr2 = [...arr2].sort();
      
        return sortedArr1.every((value, index) => value === sortedArr2[index]);
    }

    joinTaskChannel(taskId: number, onMessage: (msg: any) => void): void {

        const channelName = `task.${taskId}`;
        // if (this.subscribedChannels.has(channelName)) return; // Already subscribed
        // this.subscribedChannels.add(channelName);

        this.echo?.private(channelName)
            .listen('.task.message.sent', (e: any) => {
                // console.log(e);
                return onMessage(e.message);
            });
    }

    joinTaskUnreadChannel(onMessage: (data: any) => void): void {

        const clubId = this.currentUser?.club_id;
        const channelName = `task.unread.client.${clubId}`;
        // if (this.subscribedChannels.has(channelName)) return; // Already subscribed
        // this.subscribedChannels.add(channelName);

        this.echo?.private(channelName)
            .listen('.task.unread.client.count', (e: any) => {
                // console.log(e);
                const existingCountData: string[] = this.localStorageService.getItem("task-counter");
                if(existingCountData){
                    if(!this.areArraysIdentical(existingCountData, e.message)){
                        this.taskTableService.loadRecords(); 
                    }

                    // if(e.text && e.text !== ""){
                    //     const fullMsg = "ALERTS.new-message" + "====" + e.text;
                    //     this.alertService.triggerAlert(fullMsg, "chat");
                    // }
                }

                this.localStorageService.setItem("task-counter", e.message);
                this.taskTableService.unReadTasks = e.message;
                return onMessage(e.message);
            });
    }
}